// A11y Helper File

/**
 * Key codes for keyboard navigation
 * @readonly
 * @enum {string}
 */
const KEYBOARD_KEYS = {
    TAB: 'Tab',
    ENTER: 'Enter',
    ESC: 'Escape',
    SPACE: ' ',
    ARROW_LEFT: 'ArrowLeft',
    ARROW_RIGHT: 'ArrowRight',
    SHIFT: 'Shift',
};

/**
 * Handles the Escape key press event.
 * @param {KeyboardEvent} event - The keyboard event.
 * @param {Function} callback - The callback function to execute on Escape press.
 */
function handleEscapeKey(event, callback) {
    if (event.key === KEYBOARD_KEYS.ESC) {
        if (typeof callback === 'function') {
            callback();
        }
    }
}

/**
 * Traps focus inside a modal/dialog using jQuery.
 * @param {JQuery} $modalElement - The modal element wrapped in jQuery.
 */
function trapModalFocus($modalElement) {
    if (!$modalElement || !$modalElement.length) return;

    const focusableSelector = 'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])';

    const focusable = () => $modalElement.find(focusableSelector).filter(':visible');

    $modalElement.off('keydown.trapFocus').on('keydown.trapFocus', (event) => {
        const $focusable = focusable();
        const $first = $focusable.first();
        const $last = $focusable.last();

        if (event.key === KEYBOARD_KEYS.TAB) {
            const isFirst = $(document.activeElement).is($first);
            const isLast = $(document.activeElement).is($last);

            if (event.shiftKey && isFirst) {
                event.preventDefault();
                $last.trigger('focus');
            } else if (!event.shiftKey && isLast) {
                event.preventDefault();
                $first.trigger('focus');
            }
        }
    });

    // Only auto-focus if nothing inside is already focused
    const insideModal = $modalElement[0].contains(document.activeElement);
    if (!insideModal) {
        const $first = focusable().first();
        $first.trigger('focus');
    }
}

/**
 * Removes trapped focus from a modal by removing event listeners and resetting attributes.
 */

function removeModalFocus() {
    const modal = document.querySelector('.tt-modal');
    if (modal && modal.dataset.trapFocus === 'true') {
        modal.removeEventListener('keydown', modal.handleKeyDown);
        delete modal.dataset.trapFocus;
        delete modal.handleKeyDown;
    }
}

/**
 * Saves the currently focused element
*/
let lastFocusedElement = null;

function saveFocus() {
    lastFocusedElement = document.activeElement;
}

/**
 * Restores focus to the element that opened the modal.
 */
function restoreFocus() {
    if (lastFocusedElement) {
        // If it's a jQuery object
        if (typeof lastFocusedElement.trigger === 'function') {
            lastFocusedElement.trigger('focus');
        } else if (typeof lastFocusedElement.focus === 'function') {
            // If it's a raw DOM element
            lastFocusedElement.focus();
        }
        lastFocusedElement = null;
    }
}

// Export the functions to be available outside
export {
    KEYBOARD_KEYS,
    handleEscapeKey,
    trapModalFocus,
    removeModalFocus,
    saveFocus,
    restoreFocus,
};
